import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { AutosizedTextField } from '../../common/AutosizedTextField';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const AutosizedTextFieldWidget = () => {
    const [value, setValue] = useState('Value');
    const component = useMemo(() => _jsx(AutosizedTextField, { label: "Label", placeholder: "Placeholder", value: value, onChange: (e) => setValue(e.target.value) }), [value]);
    return {
        name: 'AutosizedTextField',
        category: 'common',
        component,
    };
};
